export default "__VITE_ASSET__DWGxGASz__"